<script setup lang="ts">
    import type { DropdownMenuItemProps } from 'reka-ui';
    import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';
    import { DropdownMenuItem, useForwardProps } from 'reka-ui';
    import { cn } from '../utils';

    const props = withDefaults(
        defineProps<
            DropdownMenuItemProps & {
                class?: HTMLAttributes['class'];
                inset?: boolean;
                variant?: 'default' | 'destructive';
            }
        >(),
        {
            variant: 'default',
        },
    );

    const delegatedProps = reactiveOmit(props, 'inset', 'variant', 'class');

    const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <DropdownMenuItem
        data-slot="dropdown-menu-item"
        :data-inset="inset ? '' : undefined"
        :data-variant="variant"
        v-bind="forwardedProps"
        :class="
            cn(
                'focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive [&_svg:not([class*=\'text-\'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*=\'size-\'])]:size-4',
                props.class,
            )
        "
    >
        <slot />
    </DropdownMenuItem>
</template>
